jQuery(document).ready(function( $ ) {


    // Use these classes to animate using AOS
    $('.zoom').attr('data-aos', 'zoom-in');
    $('.zoom').attr('data-aos-duration', '2000');
    $('.zoomup').attr('data-aos', 'zoom-in-up');
    $('.zoomup').attr('data-aos-duration', '2000');
    $('.fade').attr('data-aos', 'fade-up');
    $('.fade').attr('data-aos-duration', '2000');
    $('.flip').attr('data-aos', 'flip-up');
    $('.flip').attr('data-aos-duration', '2000');

    // Adds animation to Wordpress blockquote using AOS
    $('.wp-block-quote').attr('data-aos', 'zoom-in-up');
    $('.wp-block-quote').attr('data-aos-duration', '2000');

    // Include AOS script for animations
    $.getScript("/wp-content/themes/fptheme/inc/aos/aos.js", function() {
        AOS.init();
    });

    // Include light box script - used for Gallery Block
    $.getScript("/wp-content/themes/fptheme/inc/lightbox/simple-lightbox.js", function() {
        (function() {
            var $gallery = new SimpleLightbox('.gallery a', {});
        })();
    });

    // Include Slick - used for Hero Slider Block
    $.getScript("/wp-content/themes/fptheme/inc/slick/slick.min.js", function() {
        $.getScript("/wp-content/themes/fptheme/inc/slick-animation/slick-animation.js", function() {

            $('.slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                cssEase: 'linear',
                lazyLoad: 'progressive',
                autoplaySpeed: 8000, //3 secs
                dots: false,
                arrows: true,
                fade: !0,
                prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
	            nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
                
            }).slickAnimation();

            $('.slick-nav').on('click touch', function(e) {

                e.preventDefault();
            
                var arrow = $(this);
            
                if(!arrow.hasClass('animate')) {
                    arrow.addClass('animate');
                    setTimeout(() => {
                        arrow.removeClass('animate');
                    }, 1600);
                }
            
            });
        });
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 1) {
            $('.sticky-hide').fadeOut('fast');
            $('.sticky').addClass("sticky-header");
        } else {
            $('.sticky-hide').fadeIn('fast');
            $('.sticky').removeClass("sticky-header");
            
        }
    });

});
